.root-class-name {
  :global {
    .ant-popover-title {
      padding: 0;
      margin-bottom: 0;
    }

    .ant-popover-container {
      --ant-popover-inner-padding: 8px 0 8px 8px;
      --ant-popover-inner-content-padding: 0;
    }
  }
}

.title {
  display: flex;
  justify-content: space-between;

  .copy-button {
    padding: 0 10px 2px 0;
    height: 30px;
    width: 30px;
  }
}
